import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import OnBoardingGuide from 'shared/guides/OnBoardingGuide'
import { FadeDiv } from 'shared/components/FadeDiv'
import SendMessageHandler from 'shared/components/SendMessageHandler'
import RecipientsListModal from 'Modules/Communication/shared/components/RecipientsListModal'
import { FCWithChildren } from 'global'
import useModal from 'shared/hooks/useModal'
import { getActiveClient } from 'shared/store/clients/selectors'
import { resetObjectAndMetersFilter } from 'shared/store/sendMessage/recipients'
import LayoutContent from './LayoutContent'
import { FIND_RECIPIENTS_MODAL } from 'shared/constants/modals'
import { motion } from 'motion/react'

const Layout: FCWithChildren = ({ children }) => {
  const { type } = useModal()
  const activeClient = useSelector(getActiveClient)
  const dispatch = useDispatch()

  const isRecipientsOpen = type === FIND_RECIPIENTS_MODAL

  // Use for email, resets the objects and meters
  // This is to avoid fetching more than 1 time per client.
  useEffect(() => {
    dispatch(resetObjectAndMetersFilter())
  }, [activeClient?.id, dispatch])

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      className="appwrapper"
    >
      <OnBoardingGuide />
      <SendMessageHandler />

      {isRecipientsOpen && <RecipientsListModal />}

      <LayoutContent>{children}</LayoutContent>
    </motion.div>
  )
}

export default Layout
